import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BeneListService } from '../../../../services/beneList.service';
import { ModalService } from '../../../../services/modal.service';
import { ModalRouteService } from '../../../../services/modal-route.service';
import { BeneFormChildrenComponent } from '../bene-form.children.component';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { CommonGuiPart } from '../../commonGuiPart';
import { CityListService } from '../../../../../../common/services/cityList.service';

@Component({
  selector: 'bene-form-children-coverpath',
  templateUrl: './bene-form.children.component.coverpath.html',
})
export class BeneFormChildrenComponentCoverPath extends BeneFormChildrenComponent {
  isZipLoading: boolean = false;
  constructor(
    beneListService: BeneListService,
    modalRouteService: ModalRouteService,
    router: Router,
    activatedRouter: ActivatedRoute,
    fb: FormBuilder,
    modalService: ModalService
  ) {
    super(beneListService, modalRouteService, router, activatedRouter, fb, modalService);
  }

  async zipCodeLookup(index: number): Promise<void> {
    this.isZipLoading = true;
    const zip = this.beneForm.get('childrenList').value[index].zip;
    const cityListService = await CommonGuiPart.getLocObjByZipCode(
      zip,
      this.beneListService,
      CityListService.CHANNEL_COVERPATH
    );
    if (cityListService) {
      this.childrenList.at(index).patchValue(cityListService.getCityStateCode());
      this.clearChildValidation(index, this.invalidZip);
    } else {
      this.childrenList.at(index).get('zip').setErrors({ unsupportedZip: true });
    }
    this.isZipLoading = false;
  }

  getChildControl(group: AbstractControl, name: string): AbstractControl {
    return group.get(name);
  }
}
